import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private apiUrl = `${environment.apiUrl}/contacts`;

  constructor(private http: HttpClient) { }

  getContact(): Observable<any> {
    return this.http.get(`${this.apiUrl}`)
  }

  getWhatsapp(): Observable<any> {
    return this.http.get(`${this.apiUrl}/getWhatsapp`)
  }
  
}
